var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'triangle-defaults triangle-' + _vm.corner,style:('border-bottom: ' + _vm.borderBottom + 
        ';  border-left: ' + _vm.borderLeft + 
        '; border-right: ' + _vm.borderRight + 
        '; width: ' + _vm.width + ';')})}
var staticRenderFns = []

export { render, staticRenderFns }